import { MouseButton } from "./menu.js";
import { GridCustomToolBarButton, ToolBar, ToolBarCustomButton, ToolBarInGridButtonType, ToolBarStandardButton, ToolBarStandardButtonType } from "./toolBar.js";
import { Helper } from "../util/helper.js";
import { ComponentHelper } from "../util/componentHelper.js";
import { Config } from "../config/config.js";
import GridDetails from "./grid/gridDetails.js";
import { InGridToolBarButton } from "./editableGrid/editableGrid.js";

import { InnosoftMobileApp } from "../util/innosoftMobileApp.js";
import ToolBarContextMenu, { ToolBarContextMenuOpenParams } from "./mobile/toolBarContextMenu.js";
import React from "react";
import ReactDOM from "react-dom";
export class Grid extends React.Component<GridProps, {
    filterChanged: boolean;
    groupingChanged: boolean;
    sortChanged: boolean;
    reactTemplateRoots: any[];
}>{
    private _gridRef: HTMLElement;
    private _grid: kendo.ui.Grid = null;
    private _selectedDataItem: any = null;
    private _defined = Helper.hasValue;
    private _toolBar: ToolBar = null;
    private _selectionChangedEventDisabled = false;
    private _localDataBound: Array<(e: kendo.ui.GridDataBoundEvent) => void> = [];
    private data: any;
    private reactTemplateRoots: any[] = [];
    private dataCache = "";
    private collapsedValues: any[];
    private filterKey = `${this.props.id}_FILTER_DEFAULT_${Config.user.userName}`;
    private groupingKey = `${this.props.id}_GROUP_DEFAULT_${Config.user.userName}`;
    private sortKey = `${this.props.id}_SORT_DEFAULT_${Config.user.userName}`;
    private hasMobileTemplate: boolean = Helper.hasValue(this.props.options.columns.find(x => x.field?.toLowerCase() == "mobiletemplate"));
    private contextMenu: ToolBarContextMenu;

    constructor(props: GridProps) {
        super(props);
        this.state = {
            filterChanged: false,
            groupingChanged: false,
            sortChanged: false,
            reactTemplateRoots: []
        }
        const delay = !Helper.hasValue(props.throttleActive) || props.throttleActive ? 1000 : 0;
        this._handleStandardButtonClick = Helper.throttle(this._handleStandardButtonClick, delay);
        this._handleCustomButtonClick = Helper.throttle(this._handleCustomButtonClick, delay);
    }

    private _setColors = () => {
        if (this._defined(this._grid) && Array.isArray(this.props.rowColorRules)) {
            for (let i = 0; i < this.props.rowColorRules.length; i++) {
                const cRule = this.props.rowColorRules[i];
                this._grid.items().toArray().forEach((row, rIdx) => {
                    const $row = $(row);
                    const dataItem = this._grid.dataItem(row);
                    if (this._defined(dataItem[cRule.column]) && dataItem[cRule.column].toString() === cRule.value) {
                        $row.css({ "background-color": cRule.backgroundColor, "color": cRule.color });
                    }
                });
            }
        }
    }

    exportExcel = () => {
        this._grid.saveAsExcel();
    }

    private _hideContextMenu = (e: JQuery.Event) => {
        $(".grid-options-column--active", this._gridRef).removeClass("grid-options-column--active");
    }

    private _handleContextMenuItemSelect = (e: JQuery.TriggeredEvent) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        const dataItem = this._grid.dataItem($(e.target).closest("tr"));
        let mBtn = MouseButton.Unknown;
        if (e.button === 0) {
            mBtn = MouseButton.Left;
        }
        else if (e.button === 1) {
            mBtn = MouseButton.Middle;
        }
        else if (e.button === 2) {
            mBtn = MouseButton.Right;
        }
        if (this.props.onClickContextMenuItem)
            this.props.onClickContextMenuItem($(e.target).data("name"), mBtn, dataItem);
    }

    private _handlePageClickEvent = (e: JQuery.TriggeredEvent) => {
        const wrapper = $(e.target).closest(".grid-options-wrapper");

        this._hideContextMenu(null);
        if (wrapper.length !== 0) {
            e.stopPropagation();
            wrapper.addClass("grid-options-column--active");
        }
    }

    private _createGrid = (data, options): kendo.ui.GridOptions => {
        function pageable() {
            let pageable: boolean | kendo.ui.GridPageable = gridOptions.pageable ?? true;
            if (pageable && Config.settings.isMobileApp)
                pageable = {
                    position: "top",
                    info: false,
                    numeric: false
                }
            return pageable;
        }

        let that = this;
        this.data = JSON.parse(JSON.stringify(data));
        this.updateGridOptions(options);
        let gridOptions: kendo.ui.GridOptions = jQuery.extend(true, {}, options);
        gridOptions = ComponentHelper.getKendoGridStandardOptions({ useColumnStateManager: true, id: this.props.id, initial: gridOptions });
        let tmpDS = this._defined(gridOptions.dataSource) ? gridOptions.dataSource : {};
        let pageSize = tmpDS.pageSize;
        let schema = tmpDS.schema;
        let group = tmpDS.group;
        let aggregate = tmpDS.aggregate;
        gridOptions.toolbar = null;
        gridOptions.pageable = pageable();

        const dataSourceObj: any = {
            transport: {
                read: function (e) {
                    e.success(that.data);
                }
            },
            pageSize: this._defined(this.props.options.pageable) && !this.props.options.pageable ? undefined : pageSize || 100,
            schema: schema,
            group: group,
            change: () => {
                if (this._defined(this._grid)) {
                    if (this._selectedDataItem != null) {
                        this._selectedDataItem = null; //,this._grid.dataItem(this._grid.select());
                        if (!this._selectionChangedEventDisabled && this.props.onSelectionChanged) {
                            this.props.onSelectionChanged(this._selectedDataItem);
                        }
                        this.setState({});
                    }
                }
            },
            aggregate: aggregate
        };
        if (tmpDS.sort) {
            dataSourceObj.sort = tmpDS.sort;
        }
        gridOptions.dataSource = new kendo.data.DataSource(dataSourceObj);
        gridOptions.dataBinding = function (e) {
            if (that.props.rememberCollapsedRows)
                that.setCollapsedValues(e);
        };
        gridOptions.dataBound = function (e) {
            that._localDataBound.forEach(f => f(e));
            if ((options as kendo.ui.GridOptions).dataBound) {
                (options as kendo.ui.GridOptions).dataBound(e);
            }
            if (that.props.onDataBound)
                that.props.onDataBound(e);

            if (that.reactTemplateRoots && that.reactTemplateRoots.length > 0) {
                that.setState({ reactTemplateRoots: that.reactTemplateRoots });
                that.reactTemplateRoots = [];
            }
            if (that.props.rememberFilter && that.state.filterChanged) {
                let filter = e.sender.dataSource.filter();
                if (filter != null)
                    that.saveToClientStorage(that.filterKey, filter);
                else
                    that.removeClientStorage(that.filterKey);

                that.setState({ filterChanged: false });
            }
            if (that.props.rememberGrouping && that.state.groupingChanged) {
                let group = e.sender.dataSource.group();
                if (group != null)
                    that.saveToClientStorage(that.groupingKey, group);
                else
                    that.removeClientStorage(that.groupingKey);

                that.setState({ groupingChanged: false });
            }

            if (that.props.rememberSorting && that.state.sortChanged) {
                let sort = e.sender.dataSource.sort();
                if (sort != null)
                    that.saveToClientStorage(that.sortKey, sort);
                else
                    that.removeClientStorage(that.sortKey);

                that.setState({ sortChanged: false });
            }
            if(that.props.copyCellValue) {
                Helper.setCopyCellButtonFunction(e.sender.tbody);
            }
            e.sender.tbody.find("tr.k-master-row").on("click", function (e) {
                if (Helper.useMobileGui()) {
                    that.selectRowInternal(this);
                    InnosoftMobileApp.isMobileDevice().then(isMobileDevice => {
                        if ((isMobileDevice || !(that.props.gridDetails?.useFeature ?? false))) {
                            if (that._handleStandardButtonClick)
                                that.setState({}, () => that._handleStandardButtonClick(ToolBarStandardButtonType.EDIT));
                        }
                    })
                }
            });

            if (Helper.useMobileGui()) {
                e.sender.tbody.find("tr.k-master-row")
                    .on("touchstart", function (e) {
                        e.stopPropagation();
                    });

                e.sender.tbody.find(".mobile-context-menu")
                    .on("click", function (e) {
                        that.onContextMenuClick(e);
                    }).on("touchstart", function (e) {
                        e.stopPropagation();
                    });
            }

            if (Helper.hasValue(that.props.rowDataBound)) {
                e.sender.items().map((idx, row) => {
                    let dataItem = e.sender.dataItem(row);
                    that.props.rowDataBound(row, dataItem);
                });
            }
            if (that.props.rememberCollapsedRows)
                that.collapseRows(e);
        };
        gridOptions.group = function (e) {
            if (that.props.rememberCollapsedRows && e.groups.length > 1) {
                e.preventDefault();
            }
            if (that.props.rememberGrouping)
                that.setState({ groupingChanged: true }, () => that._grid.refresh());
        };
        gridOptions.change = function (e) {
            const dataItems = e.sender.select().map((idx, row) => {
                return e.sender.dataItem(row);
            }).get();
            that._selectedDataItem = dataItems.length <= 1 ? dataItems[0] : dataItems;
            if (dataItems.length == 0)
                that._selectedDataItem = null;
            if (!that._selectionChangedEventDisabled && that.props.onSelectionChanged) {
                that.props.onSelectionChanged(that._selectedDataItem);
            }
            that.setState({});
        };
        gridOptions.filter = function (e) {
            if (that.props.rememberFilter)
                that.setState({ filterChanged: true }, () => that._grid.refresh());
        }

        gridOptions.sort = function (e) {
            if (that.props.rememberSorting)
                that.setState({ sortChanged: true }, () => that._grid.refresh());
        }

        let noRecordsText = Helper.getTranslation("WebSMS.Grid.NoRecords");
        try {
            noRecordsText = kendo.ui.Grid.prototype.options.messages.noRecords;
        } catch {
            //
        }
        
        gridOptions.noRecords = {
            template: this.props.noRecords ?? `<div style='width: 100%'>${noRecordsText}</>`
        };

        $(this._gridRef).off("mouseup", this._handleContextMenuItemSelect);
        $("body").off("click", this._handlePageClickEvent);
        if (this.props.contextMenu instanceof Array && this.props.contextMenu.length > 0) {
            let menuItems = "";
            for (let mi of this.props.contextMenu)
                menuItems += `<div data-name='${mi.id}' title='${mi.caption}'>${mi.caption}</div>`;
            gridOptions.columns.splice(0, 0, {
                template: '<div class="grid-options-column"><i class="fal fa-ellipsis-v fa-2x" aria-hidden="true"></i><div class="grid-row-options">' + menuItems + '</div></div>',
                width: 20,
                attributes: {
                    style: "overflow:visible",
                    "class": "grid-options-wrapper"
                },
                field: "rowoptions",
                title: " "
            });

            $(this._gridRef).on("mouseup", ".grid-row-options > div", this._handleContextMenuItemSelect);

            $("body").on("click", this._handlePageClickEvent);
        }

        gridOptions.columns = ComponentHelper.getKendoGridColumns(this.props.id, gridOptions.columns);

        if (!this.hasMobileTemplate && Helper.useMobileGui()) {
            gridOptions.columns.push({
                field: "mobileTemplate",
                template: (row) => this.getDefaultMobileTemplate(options.columns, row),
                hidden: !Helper.useMobileGui(),
                width: "100%"
            });
        }

        if (Helper.useMobileGui() && this.useContextMenu(this.props.standardButtons, this.props.customButtons)) {
            gridOptions.columns.push({
                field: "mobileContextMenu",
                width: "30px",
                hidden: !Helper.useMobileGui(),
                editable: (_) => false,
                attributes: {
                    "data-field": "mobileContextMenu"
                },
                template: (row) => `
                    <div class='mobile-context-menu'>
                        <i class='fal fa-ellipsis-vertical fa-2x'></i>
                    </div>`
            })
        }

        if (Helper.hasValue(this.props.selectFilterField) && gridOptions.columns.length > 0) {
            gridOptions.columns.filter(c => c.field === this.props.selectFilterField).forEach(c => {
                if (!Helper.hasValue(c.attributes))
                    c.attributes = { "class": "select-filter-field" };
                else {
                    if (!Helper.hasValue(c.attributes.class)) {
                        c.attributes.add({ class: "select-filter-field" });
                    }
                    else {
                        const exClass = c.attributes.class;
                        const s = exClass.split(" ");
                        if (s.indexOf("select-filter-field") === -1) {
                            c.attributes.class = c.attributes.class + " c.attributes.class";
                        }
                    }
                }
            });
        }

        this._setColors();
        if (this._defined(this.props.preselectFilter) && this.props.preselectFilter !== "") {
            const preselectFilterFunction = (e: kendo.ui.GridDataBoundEvent) => {
                const grid = e ? e.sender : this._grid;

                const toSelect = $("tr", grid.tbody).filter((index, row) => {
                    return $(row).find(`td:contains('${this.props.preselectFilter}')`).length > 0;
                });
                this._selectionChangedEventDisabled = true;
                grid.select(toSelect);
                grid.trigger("change");
                this._selectionChangedEventDisabled = false;

                const idx = this._localDataBound.indexOf(preselectFilterFunction);
                if (idx > -1) {
                    this._localDataBound.splice(idx, 1);
                }
            }

            if (this._grid) {
                preselectFilterFunction(null);
            } else {
                this._localDataBound.push(preselectFilterFunction);
            }
        }

        //im ComponentHelper gesetzt
        const saveColumnsToLocalStorage = gridOptions.columnReorder;
        gridOptions.columnReorder = (e) => {
            if (e.column.field === "rowoptions") {
                setTimeout(() => {
                    this._grid.reorderColumn(0, e.column);
                }, 0);
            } else if (Array.isArray(this.props.contextMenu) && this.props.contextMenu.length > 0 && e.newIndex === 0) {
                setTimeout(() => {
                    this._grid.reorderColumn(e.oldIndex, e.column);
                }, 0);
            } else {
                saveColumnsToLocalStorage(e);
            }
        }

        this.createReactTemplateColumns(gridOptions.columns);
        gridOptions.filterMenuInit = (e) => {
            if (this.isString(schema, e.field)) {

                e.container.data("kendoPopup").bind("open", () => {
                    let currentFilterItem = this.getFilterItem(e.field);
                    let setDefaultBeginOperator = !Helper.hasValue(currentFilterItem?.value);
                    const beginOperator = e.container.find("[data-role=dropdownlist]:eq(0)").data("kendoDropDownList");
                    if (beginOperator && setDefaultBeginOperator) {
                        beginOperator.value("contains");
                        beginOperator.trigger("change");
                    }
                });

                e.container.data("kendoPopup").bind("activate", () => {
                    const firstTextBox = e.container.find("input")[0];
                    if (firstTextBox)
                        firstTextBox.focus();
                });
            }

        };
        return gridOptions;
    }
    private updateGridOptions = (options) => {
        options.columns.forEach(x => {
            if (Helper.hasValue(x.template) && Array.isArray(x.template)) {
                x.template = x.template.reduce((acc, curr) => acc + curr, "");
            }

            x.hidden = (Helper.hasValue(x.hidden) && x.hidden) || Helper.useMobileGui();
            if (!Helper.isNullOrEmpty(x.field) && x.field.toLowerCase() == "mobiletemplate") {
                x.hidden = !Helper.useMobileGui();
                x.width = "100%";
            }
            if(this.props.copyCellValue){
                Helper.setDefaultCellTemplate(x);
            }
        });
    }

    private getDefaultMobileTemplate = (kendoColumns: any[], row) => {
        const getTemplate = function (column: any) {
            let template = column.template;
            let format = column.format;
            let value = `#=data.${column.field} ?? ''#`;
            if (typeof template == "function")
                value = template(row);
            else if (template)
                value = template;
            else if (format)
                value = `#=kendo.format("${format}", data.${column.field})#`;

            return value;
        }

        let template = "";
        for (let kendoColumn of kendoColumns) {
            if (!Helper.hasValue(kendoColumn.title))
                continue;
            let columnTemplate = getTemplate(kendoColumn);
            template += `<div class='list-item__title list-item__title--small'>${kendoColumn.title}:</div><div class='list-item__row'>${columnTemplate}</div>`;
        }

        let result = "";
        try {
            result = kendo.template("<div class='list-item list-item--grid'>" + template + "</div>")(row);
        }
        catch (e) {
            result = '<div style = "color:red">Error im template:' + e.message + '</div>';
        }
        return result;
    }

    private isString = (schema, fieldName: string) => {
        if (schema && schema.model && schema.model.fields) {
            const field = schema.model.fields[fieldName]
            if (field && (field.type == "number" || field.type == "date")) {
                return false;
            }
        }
        return true;
    }

    private prepareReactTemplate = (reactTemplateFunction, dataItem) => {
        const rootId = kendo.guid();
        this.reactTemplateRoots.push({ id: rootId, dataItem: dataItem, templateFunction: reactTemplateFunction });
        return `<div id =${rootId}></ div>`;
    }

    private createReactTemplateColumns = (columns: any[]) => {
        if (!columns) {
            return;
        }
        for (var c of columns) {
            if (c.reactTemplate) {
                c.template = this.prepareReactTemplate.bind(this, c.reactTemplate);
            }
            if (!this.reactTemplateRoots) {
                this.reactTemplateRoots = [];
            }
        }
    }

    renderReactColumnTemplatesAsPortals = () => {
        if (!this.state || !this.state.reactTemplateRoots) {
            return null;
        }
        return this.state.reactTemplateRoots.map((e) => <KendoGridTemplatePortal key={e.id} kendoId={e.id}>{e.templateFunction(e.dataItem)}</KendoGridTemplatePortal>);
    }

    private _handleStandardButtonClick = (type: ToolBarStandardButtonType) => {
        if (this.props.onClickStandardButton) {
            const dataItems = this._grid.options.selectable ? this._grid.select().map((i, e) => {
                return this._grid.dataItem(e);
            }).toArray() : null;
            this.props.onClickStandardButton(type, this._selectedDataItem, dataItems);
        }
    }

    private _handleCustomButtonClick = (id: string) => {
        if (this.props.onClickCustomButton) {
            const dataItems = this._grid.options.selectable ? this._grid.select().map((i, e) => {
                return this._grid.dataItem(e);
            }).toArray() : null;
            this.props.onClickCustomButton(id, this._selectedDataItem, dataItems);
        }
    }

    private selectRowInternal = (row) => {
        this._grid.clearSelection();
        this._grid.select(row);
        this._grid.trigger("change");
    }

    // Start api
    public selectRow = (selectFilter: string, triggerChange: boolean = false) => {
        const exClass = (this.props.selectFilterField != null) ? ".select-filter-field" : "";
        const toSelect =
            $("tr", this._grid.tbody).filter((index, row) => {
                let found = $(row).find(`td${exClass}:contains('${selectFilter}')`);
                //debugger;
                return found.length > 0;
            });

        this._selectionChangedEventDisabled = !triggerChange;
        this._grid.clearSelection();
        this._grid.select(toSelect);
        this._grid.trigger("change");
        this._selectionChangedEventDisabled = false;
    }

    public getElement = () => {
        return this._gridRef;
    }

    public getDataItem = (row: HTMLElement) => {
        if (this._defined(row)) {
            return this._grid.dataItem(row);
        }

        return null;
    }

    public getGridRef = () => {
        return this._grid;
    }

    // End api


    componentDidMount() {
        this.dataCache = JSON.stringify(this.props.data);
        const gridSetting = this._createGrid(this.props.data, this.props.options);
        this._grid = $(this._gridRef).kendoGrid(gridSetting).data("kendoGrid");
        if (this.props.rememberFilter)
            this.loadFilter();
        if (this.props.rememberGrouping)
            this.loadGroup();
        if (this.props.rememberSorting)
            this.loadSort();
    }

    updateSelection = (gridProps: GridProps) => {
        if (this._defined(gridProps.selectFilter) && gridProps.selectFilter !== "") {
            const exClass = (gridProps.selectFilterField != null) ? ".select-filter-field" : "";
            const toSelect =
                $("tr", this._grid.tbody).filter((index, row) => {
                    let found = $(row).find(`td${exClass}:contains('${gridProps.selectFilter}')`);
                    //debugger;
                    return found.length > 0;
                });
            this._grid.select(toSelect);
            this._grid.trigger("change");
        }
    }

    componentDidUpdate(prevProps: GridProps) {
        // Grid neu laden wenn die Daten sich verändert haben
        if (JSON.stringify(this.props.data) !== this.dataCache) {
            this.dataCache = JSON.stringify(this.props.data);
            this.data = JSON.parse(JSON.stringify(this.props.data));
            if (this._defined(prevProps.options.pageable) && prevProps.options.pageable)
                this._grid.dataSource.page(1);
            this._grid.dataSource.read();
            this._selectedDataItem = null;

            this.updateSelection(prevProps);
        }
        else if (this.props.selectFilter != prevProps.selectFilter) {
            this._grid.clearSelection();
            this.updateSelection(this.props);
        }

        if (this.props.options != prevProps.options) {
            const gridSetting = this._createGrid(this.props.data, this.props.options);
            this._grid.setOptions(gridSetting);
        }
    }

    reloadData = () => {
        this._grid.dataSource.read();
    }

    private getFilterItem = (field: string) => {
        let filters: any = this._grid.dataSource.filter();
        return filters?.filters?.find(x => x.field == field);
    }

    private loadFilter = () => {
        let data = this.loadFromClientStorage(this.filterKey);
        this._grid.dataSource.filter(data);
    }

    private loadGroup = () => {
        let data = this.loadFromClientStorage(this.groupingKey);
        this._grid.dataSource.group(data);
    }

    private loadSort = () => {
        let data = this.loadFromClientStorage(this.sortKey);
        this._grid.dataSource.sort(data);
    }

    private saveToClientStorage = (key: string, data: any) => {
        Helper.saveDataToStorage(key, data, false);
    }

    private loadFromClientStorage = (key: string) => {
        return Helper.loadDataFromStorage(key);
    }

    private removeClientStorage = (key: string) => {
        return Helper.removeDataFromStorage(key);
    }

    private setCollapsedValues = (e) => {
        this.collapsedValues = [];
        e.sender.element.find("td[aria-expanded='false']").map((index, element) => {
            let text = $(element).find(".k-reset:first").text();
            this.collapsedValues.push(text);
        });
    }

    private collapseRows = (e) => {
        if (Helper.hasValue(this.collapsedValues)) {
            e.sender.element.find("tbody > .k-grouping-row").map((index, element) => {
                let text = $(element).find(".k-reset:first").text();
                if (this.collapsedValues.includes(text)) {
                    this._grid.collapseGroup(element);
                }
            });
        }
    }

    componentWillUnmount() {
        kendo.destroy(this._grid.element);
    }

    private onContextMenuClick(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        this.selectRowInternal(e.target.closest("tr"));

        //setState muss sein weil sonst die Buttons veraltet sind
        this.setState({}, () => this.contextMenu.openContextMenu(e.target));
    }

    private useContextMenu = (standardButtons: ToolBarStandardButton[], customButtons: GridCustomToolBarButton[]) => {
        let buttons: InGridToolBarButton[] = [];
        if (Array.isArray(standardButtons)) {
            for (let standardButton of standardButtons) {
                if (standardButton.type == ToolBarStandardButtonType.EDIT || standardButton.type == ToolBarStandardButtonType.DELETE)
                    return true;
            }
        }

        if (Array.isArray(customButtons)) {
            for (let customButton of customButtons) {
                if (customButton.useContextMenu)
                    return true;
            }
        }

        return false;
    }

    private openContextMenu = (params: ToolBarContextMenuOpenParams) => {
        if (params.e.event && params.e.event.type == "contextmenu")
            params.e.preventDefault();

        for (let btn of params.buttons) {
            params.enable(btn, btn.enabled(null));
        }
    }

    render() {
        const stdBtn: Array<ToolBarStandardButton> = [], cusBtn: Array<ToolBarCustomButton> = [];

        if (Array.isArray(this.props.standardButtons)) {
            for (let i = 0; i < this.props.standardButtons.length; i++) {
                const btn = this.props.standardButtons[i];
                stdBtn.push({
                    caption: btn.caption,
                    enabled: btn.enabled && (btn.type === ToolBarStandardButtonType.EDIT || btn.type === ToolBarStandardButtonType.DELETE ? this._selectedDataItem !== null : true),
                    type: btn.type
                });
            }
        }

        if (Array.isArray(this.props.customButtons)) {
            for (let i = 0; i < this.props.customButtons.length; i++) {
                const btn = this.props.customButtons[i];
                cusBtn.push({
                    caption: btn.caption,
                    enabled: btn.enabled && (!btn.autoEnabledOnRecordSelected || this._selectedDataItem !== null),
                    iconClass: btn.iconClass,
                    id: btn.id,
                    width: btn.width,
                    useContextMenu: btn.useContextMenu
                });
            }
        }

        const cssProps = Helper.hasValue(this.props.styleContainer) ? this.props.styleContainer : null;
        const gridId = Helper.hasValue(this.props.id) ? this.props.id : kendo.guid();

        return (<>
            {this.renderReactColumnTemplatesAsPortals()}
            <div className="flex-container grid-container" style={cssProps as any} >
                <ToolBar standardButtons={stdBtn}
                    customButtons={cusBtn}
                    handleStandardButtonClick={this._handleStandardButtonClick}
                    handleCustomButtonClick={this._handleCustomButtonClick}
                    useFloatingButtons={Helper.useMobileGui() && (this.props.useFloatingButtons ?? false)}
                    contextMenu={{
                        use: Helper.useMobileGui(),
                        target: gridId,
                        filter: "tbody>tr",
                        visible: Helper.useMobileGui(),
                        open: this.openContextMenu,
                        ref:(ref) => this.contextMenu = ref
                    }}
                    ref={r => this._toolBar = r}
                />
                <div className="flex-container flex-container--row flex-container__item">
                    <div className="flex-container flex-container__item" ref={(r) => this._gridRef = r} id={gridId}></div>
                    <GridDetails
                        columns={this.props.options.columns}
                        dataItem={this._selectedDataItem}
                        visible={Helper.useMobileGui() && (this.props.gridDetails?.useFeature ?? false)}>
                        {this.props.gridDetails?.children}
                    </GridDetails>
                </div>
            </div>
        </>
        );
    }
}

interface KendoGridTemplatePortalProps extends React.PropsWithChildren { kendoId: string }
class KendoGridTemplatePortal extends React.Component<KendoGridTemplatePortalProps, any> {
    private element;

    constructor(props) {
        super(props);
        this.element = document.getElementById(this.props.kendoId);
    }

    render() {
        return ReactDOM.createPortal(this.props.children, this.element);
    }
}

export interface GridProps extends React.PropsWithChildren {
    id: string; //wird für die Speicherung von Spaltenposition & Spaltenbreite benötigt. soll "fest" sein, keine GUIDs die beim Laufzeit generiert werden
    data: any;
    options: any;
    onSelectionChanged?(dataItem: any);
    onDataBound?(e: any);
    standardButtons?: Array<ToolBarStandardButton>;
    customButtons?: Array<GridCustomToolBarButton>;
    onClickStandardButton?(type: any /*Innosoft.Core.Components.ToolBarStandardButtonType*/, dataItem: any, allItems?: Array<any>);
    onClickCustomButton?(id: string, dataItem: any, allItems?: Array<any>);
    preselectFilter?: string;
    selectFilter?: string; // Selektion, die nach dem neubinden der Daten (wenn diese sich geändert habe!) vorgenommen wird
    selectFilterField?: string;
    rowColorRules?: Array<GridPropsRowColorRule>;
    contextMenu?: Array<GridContextMenuItem>;
    onClickContextMenuItem?(id: string, mouseButton: any/*Innosoft.Core.Components.MouseButton*/, dataItem: any);
    styleContainer?: string | {};
    rememberFilter?: boolean;
    rememberGrouping?: boolean;
    rememberSorting?: boolean;
    rowDataBound?: (row: HTMLElement, dataItem: any) => void;
    rememberCollapsedRows?: boolean;
    gridDetails?: {
        useFeature: boolean;
        children?: React.ReactNode;
    };
    useFloatingButtons?: boolean;
    throttleActive?: boolean;
    copyCellValue?: boolean;
    noRecords?: string | Function;
}

interface GridContextMenuItem {
    id: string,
    caption: string;
}

interface GridPropsRowColorRule {
    column: string;
    value: any;
    backgroundColor: string;
    color: string;
}